export const TEST_ID = 'tabPanelBatteryOverview';
